function reorderAvailability(gridEl) {
  if (!gridEl) return;
  const items = [...gridEl.children];
  const available = items.filter((li) => li.dataset.available !== 'false');
  const unavailable = items.filter((li) => li.dataset.available === 'false');
  if (!unavailable.length) return;
  available.forEach((li) => gridEl.appendChild(li));
  unavailable.forEach((li) => gridEl.appendChild(li));
}

document.addEventListener('DOMContentLoaded', () => {
  // Collections page — initial render
  reorderAvailability(document.getElementById('product-grid'));

  // Watch for AJAX re-renders triggered by facets.js
  const container = document.getElementById('ProductGridContainer');
  if (container) {
    new MutationObserver(() => {
      reorderAvailability(container.querySelector('#product-grid'));
    }).observe(container, { childList: true, subtree: false });
  }

  // Search page uses full-page navigation, so one-time reorder is sufficient
  document.querySelectorAll('.product-grid').forEach((grid) => {
    if (grid.id !== 'product-grid') reorderAvailability(grid);
  });
});
